import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IField } from '@bdeo-motor/smartphoto-entities';

@Component({
  selector: 'radio-list-input',
  templateUrl: './field-write-radioList.component.html',
  styleUrls: ['./field-write-radioList.component.scss']
})
export class FieldWriteRadioListComponent {
  @Input({ required: true }) field!: IField;
  @Output() public input = new EventEmitter();

  public value: unknown = null;

  protected changeHandler(value: unknown): void {
    this.value = value;
    this.input.emit({ target: this });
  }
}
